function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FF0026",
  cx: "12",
  cy: "12",
  r: "12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.59 12.092a.674.674 0 01.963 0l1.043 1.06a1.049 1.049 0 000 1.465l1.86 1.89a.174.174 0 010 .244l-1.03 1.046a.674.674 0 01-.963 0l-3.264-3.314a.7.7 0 010-.978zm12.44-4.756a.337.337 0 01.481 0c.696.706.694.707 1.389 1.413a.35.35 0 010 .49l-8.077 8.204a.337.337 0 01-.481 0l-3.264-3.315a.35.35 0 010-.489l1.39-1.415a.337.337 0 01.482 0l1.392 1.415a.337.337 0 00.481 0zm-3.88-.134a.674.674 0 01.963 0l.924.939a.174.174 0 010 .245l-4.332 4.4a.169.169 0 01-.241 0l-1.03-1.046a.98.98 0 00-.486-.27z",
  fill: "#FFF"
}))));